import { render, staticRenderFns } from "./PageFrame.vue?vue&type=template&id=daa6f524&"
import script from "./PageFrame.vue?vue&type=script&lang=js&"
export * from "./PageFrame.vue?vue&type=script&lang=js&"
import style0 from "./PageFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports